/**
 * ClientSelector — dropdown nativo de tax_clients.
 *
 * Recibe el value (clientId) + onChange + lista de TaxClient. Si la
 * lista está vacía o cargando, muestra placeholder.
 */

import { Building2 } from 'lucide-react'

import { type TaxClient } from '@/lib/api-pdf-templates'

interface Props {
  value: string
  onChange: (clientId: string) => void
  clients: TaxClient[]
  loading?: boolean
  disabled?: boolean
}

export function ClientSelector({ value, onChange, clients, loading, disabled }: Props) {
  return (
    <div className="flex items-center gap-2">
      <Building2 className="h-4 w-4 text-fg-muted" />
      <label htmlFor="client-selector" className="text-sm font-medium text-fg-secondary">
        Tax-Client:
      </label>
      <select
        id="client-selector"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading}
        className="rounded-md border border-border bg-bg-surface px-3 py-1.5 text-sm text-fg-primary disabled:cursor-not-allowed disabled:opacity-60 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
      >
        {loading && <option value="">Cargando…</option>}
        {!loading && clients.length === 0 && (
          <option value="">Sin tax-clients</option>
        )}
        {!loading && clients.length > 0 && !value && (
          <option value="">— Seleccione —</option>
        )}
        {clients.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name} (NIT {c.nit})
          </option>
        ))}
      </select>
    </div>
  )
}
